import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Subject, Subscription } from 'rxjs';
import { DataService } from 'src/app/services/data.service';
import * as XLSX from 'xlsx';
import { ConfirmReservationDialogComponent } from '../dialogs/confirm-reservation-dialog/confirm-reservation-dialog.component';
import { finalize, map } from 'rxjs/operators';
import { FirebaseStorageService } from 'src/app/services/firebase-storage.service';

import { MatSnackBar } from '@angular/material/snack-bar';
import { CustomPopupComponent } from '../dialogs/custom-popup/custom-popup.component';

@Component({
  selector: 'app-upload-reportage-relationships',
  templateUrl: './upload-reportage-relationships.component.html',
  styleUrls: ['./upload-reportage-relationships.component.sass']
})
export class UploadReportageRelationshipsComponent implements OnInit {
  type_accept: string = '.xlsx';
  selectedFiles: File = null;
  reportageForm: FormGroup;
  routeSub: Subscription;
  title: string;
  message: string;
  ok_txt: string;
  showPrimarySpinner: boolean = false;
  files: any[] = [];
  files_list: any[] = [];


  constructor(
    public dataService: DataService,
    private router: Router,
    private route: ActivatedRoute,
    private formBuilder: FormBuilder,
    public dialog: MatDialog,
    private translate: TranslateService,
    public firebaseStorageService: FirebaseStorageService,
    private snackbar: MatSnackBar

  ) { }

  ngOnInit() {
    this.reportageForm = this.formBuilder.group({
      id: new FormControl(0, Validators.required),
    });

    this.dataService.getRole().subscribe(res => {
      if ((res != 'superadmin') && (res != 'admin')){
        this.router.navigate(['/welcome']);
      }

    });
    
  }

  uploadReportageRelationships() {
    this.showPrimarySpinner = true;
    let workBook = null;
    let jsonData = null;
    const reader = new FileReader();



    if (this.selectedFiles != null) {
      const file = this.selectedFiles[0]
      reader.onload = (event) => {
        const data = reader.result;
        workBook = XLSX.read(data, { type: 'binary' });
        jsonData = workBook.SheetNames.reduce((initial, name) => {
          const sheet = workBook.Sheets[name];
          initial = XLSX.utils.sheet_to_json(sheet);
          return initial;
        }, {});
        let params = {}
        this.routeSub = this.route.params.subscribe(r => {
          params['reportage_id'] = r.id_reportage
        })

        params['excel_file'] = JSON.stringify(jsonData);

        this.translate.get('alerts.atention').subscribe(res => {
          this.title = res;
        })

        this.translate.get('alerts.checkUploadReportageRelationship').subscribe(res => {
          this.message = res;
        })

        this.translate.get('buttons.ok').subscribe(res => {
          this.ok_txt = res;
        })

        
        this.dataService.checkReportageRelationships(params).subscribe(res => {
          this.showPrimarySpinner = false;
          this.message = this.message.replace('{{modify}}', res.modify)
          this.message = this.message.replace('{{new_relationship}}', res.new_relationship)


          let dialogRef = this.dialog.open(ConfirmReservationDialogComponent, {
            data: {
              message: this.message,
              title: this.title,
              ok_txt: this.ok_txt,
            }
          }).afterClosed().subscribe(res2 => {

            if (res2 === true) {
              this.showPrimarySpinner = true;
              
              this.dataService.uploadReportageRelationships(params).subscribe(res3 => {
                if (res3.status == 'ok') {
                  this.translate.get('alerts.upload_ok').subscribe(res4 => {
                    this.showPrimarySpinner = false;
                    this.snackbar.openFromComponent(CustomPopupComponent, { data: res4, duration: 4000 })
                  })
                }
                else {
                  this.translate.get('alerts.upload_reportageRelationships_error').subscribe(res => {
                    this.showPrimarySpinner = false;
                    this.snackbar.openFromComponent(CustomPopupComponent, { data: res, duration: 4000 })
                  })
                }
              })
            }


          })
        })
      }
      reader.readAsBinaryString(file);
    }
    else {
      this.translate.get('alerts.file_required').subscribe(res4 => {
        this.showPrimarySpinner = false;
        this.snackbar.openFromComponent(CustomPopupComponent, { data: res4, duration: 4000 })
        return false;
      })
    }
  }

  selectFile(event, type) {
    if (type == 'primary') {
      this.selectedFiles = event.target.files;
    }
    // else {
    //   this.selectedSecondaryFiles = event.target.files;
    // }

  }

}
